var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"growthFileShengya"},[_c('div',{staticClass:"rzqn"},[_c('div',{staticClass:"rzqnbox"},[_c('ul',{staticClass:"biaoContent"},_vm._l((_vm.norm),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"top"},[_vm._v(_vm._s(item.score))]),_c('div',{staticClass:"middle",style:({
              bottom:(item.lnorm/200*333.9)+'px',
              height:(item.rnorm-item.lnorm)/200*333.9+'px'
            })}),_c('div',{staticClass:"bottom",style:({height:item.score/200*333.9+'px'})})])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }